import { sample } from 'effector';
import { changeActiveFilterEv, resetGradientEv } from './events.js';
import { $activeFilters } from './stores.js';

sample({
  source: $activeFilters,
  clock: changeActiveFilterEv,
  fn: (source, clock) => {
    if (clock.field === 'gradient') {
      if (clock.value === null)
        return {
          ...source,
          gradient: [],
        };
      if (
        source.gradient.every(
          (item) => item.min !== clock.value.min && item.max !== clock.value.max
        )
      ) {
        return {
          ...source,
          gradient: [...source.gradient, clock.value],
        };
      }
      return {
        ...source,
        gradient: source.gradient.filter(
          (item) => item.min !== clock.value.min && item.max !== clock.value.max
        ),
      };
    }
    if (source[clock.field] === clock.value) {
      return { ...source, [clock.field]: '' };
    }
    return { ...source, [clock.field]: clock.value };
  },
  target: $activeFilters,
});

sample({
  clock: resetGradientEv,
  fn: () => {
    return {
      field: 'gradient',
      value: null,
    };
  },
  target: changeActiveFilterEv,
});
